export const gcpKeys = {
  all: ['gcp'] as const,
  projects: () => [...gcpKeys.all, 'projects'] as const,
  activeConnection: () => [...gcpKeys.all, 'activeConnection'] as const,
  databases: (projectId: string) => [...gcpKeys.all, 'databases', projectId] as const,
};
